<template>
  <div class="event event--purple">
    <div class="event__wrapper">
      <div class="event__text">
        <h3 class="event__date">
          <span class="event__day">{{ day }}</span>
          <span class="event__month">{{ month }}</span>
        </h3>
        <h5 class="event__title">
          {{ title }}
        </h5>
        <p class="event__info">
          {{ time }}
          //
          {{ location }}
        </p>
      </div>
      <figure class="event__image">
        <img :src="image" :alt="title">
        <span class="event__category" v-if="primaryFormat">{{ primaryFormat }}</span>
      </figure>
      <a :href="link" class="event__link" />
    </div>
    <a :href="link" class="event__button btn btn--white btn--small">Event Details</a>
  </div>
</template>

<script>
export default {
  name: 'Event',
  props: {
    link: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    day: {
      type: String,
      default: ''
    },
    month: {
      type: String,
      default: ''
    },
    time: {
      type: String,
      default: ''
    },
    location: {
      type: String,
      default: ''
    },
    image: {
      type: String,
      default: ''
    },
    primaryFormat: {
      type: String,
      default: ''
    }
  }
};
</script>

<style></style>
